import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { TextMedia as Original } from 'components/organisms'
import { TextMediaSettings, TextMediaFloatingSettings } from './TextMediaSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import {
  imageDefaultProps,
  imageItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'
import { getTextEditor } from '../TextEditor'
import {
  videoDefaultProps,
  videoItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/VideoToolbarSection'
import {
  ctaDefaultProps,
  ctaItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/CtaToolbarSection'
import {
  layoutDefaultProps,
  layoutItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'
import { getItemChildren } from 'react-pagebuilder/utils/node'
import { buttonItemParams } from '../Button'

export const defaultProps = {
  ...videoDefaultProps(),
  ...imageDefaultProps(),
  ...ctaDefaultProps('Call to action', '', 'right'),
  ...layoutDefaultProps('lg'),
  refId: '',
  size: 'lg',
  mediaPos: 'left',
  theme: '',
}

export const textMediaItemParams = (enabled, id, blockProps, children) => ({
  ...videoItemParams(blockProps),
  ...imageItemParams(blockProps),
  ...ctaItemParams(blockProps, enabled),
  ...layoutItemParams(blockProps),
  pk: id,
  name: getTextEditor(children?.[0], enabled),
  intro: getTextEditor(children?.[1], enabled),
  description: getTextEditor(children?.[2], enabled),
  children: getItemChildren(enabled, children?.[3], buttonItemParams),
})

export const dynamicProps = []

export const TextMedia: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-text-media ${props.className}`}>
        <Original
          item={textMediaItemParams(enabled, id, blockProps, children)}
          refId={blockProps.refId}
          size={blockProps.size}
          mediaPos={blockProps.mediaPos}
          theme={blockProps.theme}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

TextMedia.craft = withCraft({
  name: 'TextMedia',
  defaultProps: defaultProps,
  settings: TextMediaSettings,
  floatingSettings: TextMediaFloatingSettings,
})
